import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { ApiBaseService } from './api-base.service';
import { SharedService } from './shared.service';

import { BuyerType, NewTransactionGiftcardModel, NewTransactionMarketCouponPointsModel, NewTransactionPointsModel, NewTransactionProductModel, NewTransactionTicketModel, TransactionAccumulateModel, TransactionGreetingModel, TransactionPointsFilterModel, TransactionTransferModel, NewTransactionPackageModel, TransactionPackageModel, MyGivisModel, NewTransactionCouponModel } from '@models/TransactionModel';
import { TransactionModel } from '@models/TransactionModel';
import { VendorStoreCustomer, VendorStoreModel } from '@models/VendorModel';
import { CardIssueStatus, CardIssueType, Country, PointTransactionType } from '@models/Enums';
import { CouponModel } from '@models/CouponModel';
import { TransactionNotesModel } from '@models/TransactionModel';
import { QRInformation } from '@shared/models/QRInformation';
import { GiftcardModel } from '@shared/models/GiftcardModel';
import { TicketModel } from '@shared/models/TicketModel';
import { ProductModel } from '@shared/models/ProductModel';
import { CustomerCardIssueModel, CustomerCardModel } from '@shared/models/CardModel';
import { CustomerGiveawayRegisterModel } from '@shared/models/CustomerModel';
import { ScratchModel } from '@shared/models/ScratchModel';
import { PackageScratchCustomerModel } from '@shared/models/PackageScratchCustomerModel';
import { CommunityFormModel } from '@shared/models/CommunityModel';
import { AssignCustomerStickerModel, LoyaltyPlanCustomerStickerModel, LoyaltyPlanModel } from '@shared/models/LoyaltyPlanModel';


@Injectable()
export class ApiTransactionService extends ApiBaseService {

    constructor(public http: HttpClient, public sharedService: SharedService) {
        super(http, sharedService);
    }

    // Coupons API //

    // GET api/admin/transactions/reads/v1/{id}
    getBasicTransaction(id: number, country?: Country): Promise<TransactionModel> {

        return this.http.get(`${this.baseUrl}/api/admin/transactions/basic/reads/v1/${id}`, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionModel(result);

                    return transaction;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de la transacción: ${errMsg}`));
                }
            );
    }

    // GET: api/admin/scratches/reads/v1/{id}
    getFullScratch(id: number, country?: Country): Promise<ScratchModel> {

        return this.http.get(`${this.baseUrl}/api/admin/scratches/reads/v1/${id}`, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    return new ScratchModel(result);
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de las transacciones: ${errMsg}`));
                }
            );
    }

    // GET api/admin/coupons/reads/v1/{id}
    getBasicCoupon(id: number,country?: Country): Promise<CouponModel> {

        return this.http.get(`${this.baseUrl}/api/admin/coupons/reads/v1/${id}`, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    const coupon = new CouponModel(result);

                    return coupon;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de la transacción: ${errMsg}`));
                }
            );
    }

    // GET api/admin/coupons/welcome/reads/v1
    getWelcomeCoupon(): Promise<CouponModel> {

        return this.http.get(`${this.baseUrl}/api/admin/coupons/welcome/reads/v1`, this.getHttpOptions())
            .toPromise().then(
                (result: any) => {

                    const coupon = new CouponModel(result);

                    return coupon;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de la transacción: ${errMsg}`));
                }
            );
    }

    // GET api/admin/coupons/showapp/reads/v1
    getActiveCoupons(): Promise<CouponModel[]> {
        return this.http.get(`${this.baseUrl}/api/admin/coupons/showapp/reads/v1`, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    const coupons = results.map(x => {
                        return new CouponModel(x);
                    });

                    return coupons;
                },
                (err: HttpErrorResponse) => {
                    const errMsg = this.getErrorMsg(err);
                    return Promise.reject(new Error(`Error al cargar información de la transacción: ${errMsg}`));
                }
            );
    }

    // GET api/admin/coupons/showapp/lastexpired/reads/v1
    getLastExpiredCoupons(): Promise<CouponModel[]> {
        return this.http.get(`${this.baseUrl}/api/admin/coupons/showapp/lastexpired/reads/v1`, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    const pastCoupons = results.map(x => {
                        return new CouponModel(x);
                    });
                    return pastCoupons;
                },
                (err: HttpErrorResponse) => {
                    const errMsg = this.getErrorMsg(err);
                    return Promise.reject(new Error(`Error al cargar información de la transacción: ${errMsg}`));
                }
            );
    }



    // GET api/admin/transactions/reads/v1/{id}
    getFullTransaction(id: number, country?: Country): Promise<TransactionModel> {

        return this.http.get(`${this.baseUrl}/api/admin/transactions/reads/v1/${id}`, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionModel(result);

                    return transaction;
                }
            );
    }

    // GET api/admin/transactions/reads/v1/{id}
    getNoSessionFullTransaction(id: number, country: Country): Promise<TransactionModel> {

        return this.http.get(`${this.baseUrl}/api/admin/transactions/reads/v1/${id}`, this.getHttpOptionsWithoutSession(country))
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionModel(result);

                    return transaction;
                }
            );
    }

    // GET: api/admin/Partner/vendor/reads/v1/{id}
    getTransactionsByStore(storeId: number): Promise<TransactionModel[]> {

        this.refreshSession();

        return this.http.get(`${this.baseUrl}/api/admin/partner/vendor/reads/v1/${storeId}`, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    // Sort in Descending order (high to low)
                    const orders = results.map((result: any) => {

                        return new TransactionModel(result);
                    }).sort((a: TransactionModel, b: TransactionModel) => b.redeemedAt.getTime() - a.redeemedAt.getTime());

                    return orders;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de las órdenes: ${errMsg}`));
                }
            );
    }

    // GET: api/admin/Partner/vendor/reads/v1/{id}
    getTransactionsByUser(userId: number): Promise<TransactionModel[]> {

        this.refreshSession();

        return this.http.get(`${this.baseUrl}/api/admin/partner/user/reads/v1/${userId}`, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    // Sort in Descending order (high to low)
                    const orders = results.map((result: any) => {

                        return new TransactionModel(result);
                    }).sort((a: TransactionModel, b: TransactionModel) => b.redeemedAt.getTime() - a.redeemedAt.getTime());

                    return orders;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de las órdenes: ${errMsg}`));
                }
            );
    }

    // GET api/admin/transactions/package/reads/v1/{id}
    getFullPackageTransaction(id: number, country?: Country): Promise<TransactionPackageModel> {

        return this.http.get(`${this.baseUrl}/api/admin/transactions/package/reads/v1/${id}`, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionPackageModel(result);

                    return transaction;
                }
            );
    }



    // GET api/admin/transactions/givis/customer/reads/v1/{id}
    /**
     * Devuelve todos los Givi del usuario (CustomerId o CustomerOwnerId).
     * @param {number} customerId - El Id del usuario cuyas transacciones desea recuperar.
     * @returns una Promesa que retorna una lista de de givis (TransactionModel).
     */
    getGivisByCustomer(customerId: number): Promise<TransactionModel[]> {

        return this.http.get(`${this.baseUrl}/api/admin/transactions/givis/customer/reads/v1/${customerId}`, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    // Todas las transacciones
                    let allTransactions = results.map(x => {

                        return new TransactionModel(x);
                    });

                    // Filtrar los Givis de las transacciones que el usuario ha hecho o recibido
                    allTransactions = allTransactions.filter(x => x.customerOwnerId == customerId || x.customerId == customerId);

                    return allTransactions;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de las órdenes: ${errMsg}`));
                }
            );
    }

    // GET api/admin/transactions/basic/givis/customer/reads/v1/{id}
    /**
     * Devuelve todos los Givi del usuario (CustomerId y CustomerOwnerId).
     * @param {number} customerId - El Id del usuario cuyas transacciones desea recuperar.
     * @returns una Promesa que retorna una lista de de givis (TransactionModel).
     */
    getBasicGivisByCustomer(customerId: number, country?: Country): Promise<TransactionModel[]> {

        return this.http.get(`${this.baseUrl}/api/admin/transactions/basic/givis/customer/reads/v1/${customerId}`, this.getHttpOptions(country))
            .toPromise().then(
                (results: any) => {

                    // Todas las transacciones
                    let allTransactions = results.map(x => {

                        return new TransactionModel(x);
                    });

                    // Filtrar los Givis de las transacciones que el usuario ha hecho o recibido
                    allTransactions = allTransactions.filter(x => x.customerOwnerId == customerId || x.customerId == customerId);

                    return allTransactions;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de las órdenes: ${errMsg}`));
                }
            );
    }

    // GET api/admin/transactions/givis/customer/reads/v1/{id}
    /**
     * Devuelve todos los Cupones del usuario, donde él es el dueño actual (CustomerOwnerId).
     * @param {number} customerOwnerId - El Id del usuario donde es dueño de los Givis (transacciones).
     * @returns una Promesa que retorna una lista de cupones donde el usuario es dueño (TransactionModel).
     */
    getCouponsByCustomerOwner(customerOwnerId: number): Promise<TransactionModel[]> {

        // TODO: Optimizar esto con una llamada a un Api que filtre esto en el servidor
        return this.http.get(`${this.baseUrl}/api/admin/transactions/givis/customer/reads/v1/${customerOwnerId}`, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    // Todas las transacciones
                    let allTransactions = results.map(x => {

                        return new TransactionModel(x);
                    });

                    // Filtrar solo las transacciones en que el usuario es dueño del Givi
                    allTransactions = allTransactions.filter(x => x.customerOwnerId == customerOwnerId &&
                        (x.type == PointTransactionType.PurchaseCoupons ||
                            x.type == PointTransactionType.ReceivedCoupons ||
                            x.type == PointTransactionType.ReceivedCouponPoints ||
                            x.type == PointTransactionType.ExchangeCoupons));

                    return allTransactions;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de las órdenes: ${errMsg}`));
                }
            );
    }

    // GET api/admin/transactions/givis/customer/reads/v1/{id}
    /**
     * Devuelve todos los Givis del usuario, donde él es el dueño actual (CustomerOwnerId).
     * @param {number} customerOwnerId - El Id del usuario donde es dueño de los Givis (transacciones).
     * @returns una Promesa que retorna una lista de givis donde el usuario es dueño (TransactionModel).
     */
    getGivisByCustomerOwner(customerOwnerId: number): Promise<TransactionModel[]> {

        // TODO: Optimizar esto con una llamada a un Api que filtre esto en el servidor 
        return this.http.get(`${this.baseUrl}/api/admin/transactions/givis/customer/reads/v1/${customerOwnerId}`, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    // Filtrar todas las transacciones en que el usuario es dueño del Givi
                    // * Se excluye las transacciones de compra y asignación de puntos
                    let allTransactions = results.map(x => new TransactionModel(x))
                        .filter(x => x.customerOwnerId == customerOwnerId &&
                            x.type != PointTransactionType.PurchasePoints &&
                            x.type != PointTransactionType.ReceivedPoints)

                    return allTransactions;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de las órdenes: ${errMsg}`));
                }
            );
    }

    // GET: api/admin/transactions/mygivis/customer/reads/v1/{id}

    getMyGivisByCustomerOwner(customerOwnerId: number): Promise<MyGivisModel> {

        // TODO: Optimizar esto con una llamada a un Api que filtre esto en el servidor 
        return this.http.get(`${this.baseUrl}/api/admin/transactions/mygivis/customer/reads/v1/${customerOwnerId}`, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    let myGivis = new MyGivisModel(results);
                    myGivis.transactions = myGivis.transactions.filter(x => x.customerOwnerId == customerOwnerId &&
                        x.type != PointTransactionType.PurchasePoints &&
                        x.type != PointTransactionType.ReceivedPoints);

                    return myGivis;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de las órdenes: ${errMsg}`));
                }
            );
    }

    // GET api/admin/transactions/package-scratches/customer/reads/v1/{id}
    /**
     * Devuelve todos los Scratch del usuario, donde él es el dueño actual (CustomerOwnerId).
     * @param {number} customerOwnerId - El Id del usuario donde es dueño de los Scratch (transacciones).
     * @returns una Promesa que retorna una lista de Scratch donde el usuario es dueño (PackageScratchModel).
     */
    getPackageScratchesByCustomerOwner(customerOwnerId: number): Promise<PackageScratchCustomerModel[]> {

        return this.http.get(`${this.baseUrl}/api/admin/transactions/package-scratches/customer/reads/v1/${customerOwnerId}`, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    // Filtrar todas las transacciones en que el usuario es dueño del Givi
                    // * Se excluye las transacciones de compra y asignación de puntos
                    let allTransactions = results.map(x => new PackageScratchCustomerModel(x))
                        .filter(x => x.customerOwnerId == customerOwnerId)

                    return allTransactions;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de las órdenes: ${errMsg}`));
                }
            );
    }

    // GET api/admin/transactions/customer/reads/v1/{id}
    getPurchasesByCustomer(customerId: number): Promise<TransactionModel[]> {

        return this.http.get(`${this.baseUrl}/api/admin/transactions/customer/reads/v1/${customerId}`, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    // Filtrar todas las transacciones en que el usuario compro el Givi
                    // * Se excluye las transacciones de compra y asignación de puntos
                    let allTransactions = results.map(x => new TransactionModel(x))
                        .filter(x => {
                            if (x.buyerType == BuyerType.Company) {
                                return false;
                            }
                            // Verifica si la transacción es de "Puntos de compra" y "Puntos recibidos" 
                            // y el ID del usuario es el dueño del Givi se retorna
                            if (x.type == PointTransactionType.PurchasePoints && x.type == PointTransactionType.ReceivedPoints) {
                                return x.customerOwnerId == customerId;
                            }
                            // Solo el usuario que compro el Givi
                            return x.customerId == customerId;
                        })
                        .sort((a, b) => {

                            if (a.redeemedAt && !b.redeemedAt) {

                                //a tiene redeemedAt pero b no entonces b usa createdAt
                                return b.createdAt - a.redeemedAt;
                            } else if (!a.redeemedAt && b.redeemedAt) {

                                //b tiene redeemedAt pero a no, entonces a usa createdAt
                                return b.redeemedAt - a.createdAt;
                            } else if (a.redeemedAt && b.redeemedAt) {

                                // Ambos tienen redeemedAt, ordenar por redeemedAt
                                return b.redeemedAt - a.redeemedAt;
                            } else {

                                // Ninguno o solo uno tiene redeemedAt, ordenar por createdAt
                                return b.createdAt - a.createdAt;
                            }
                        });

                    return allTransactions;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de las órdenes: ${errMsg}`));
                }
            );
    }

    // GET: api/admin/transactions/points/customer/reads/v1
    getTransactionPointsByCustomer(filter: TransactionPointsFilterModel): Promise<TransactionModel[]> {

        return this.http.put(`${this.baseUrl}/api/admin/transactions/points/customer/reads/v1`, filter, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    // Filtrar todas las transacciones de puntos que el usuario ha hecho o recibido
                    let allTransactions = results.map(x => new TransactionModel(x))
                        .filter((x: TransactionModel) => {

                            // Todas transacciones de puntos del usuario
                            if (x.customerOwnerId == filter.customerId || x.customerId == filter.customerId) {

                                // Puntos Gastados
                                if (x.buyerType == BuyerType.Customer && x.customerId == filter.customerId) {
                                    // Regalo puntos (regaló o acumulo)
                                    if (x.type == PointTransactionType.PurchaseCouponPoints ||
                                        x.type == PointTransactionType.ReceivedCouponPoints ||
                                        x.type == PointTransactionType.ExchangeCouponPoints) {
                                        return true;

                                    }
                                    // Compro POPs, Regalos o Tickets on puntos
                                    else if (x.type == PointTransactionType.PurchaseProducts || x.type == PointTransactionType.ExchangeProducts ||
                                        x.type == PointTransactionType.PurchaseGiftcards || x.type == PointTransactionType.ExchangeGiftcards ||
                                        x.type == PointTransactionType.PurchaseEventTickets || x.type == PointTransactionType.ExchangeEventTickets) {
                                        return true;
                                    }
                                    return false;
                                }

                                // Puntos Recibidos
                                if (x.customerOwnerId == filter.customerId) {
                                    // Recibió o acumulo puntos
                                    return (x.type == PointTransactionType.ReceivedPoints ||
                                        x.type == PointTransactionType.ExchangeCouponPoints);
                                }
                            }
                            return false;
                        })
                        .sort((a, b) => {

                            if (a.redeemedAt && !b.redeemedAt) {

                                //a tiene redeemedAt pero b no entonces b usa createdAt
                                return b.createdAt - a.redeemedAt;
                            } else if (!a.redeemedAt && b.redeemedAt) {

                                //b tiene redeemedAt pero a no, entonces a usa createdAt
                                return b.redeemedAt - a.createdAt;
                            } else if (a.redeemedAt && b.redeemedAt) {

                                // Ambos tienen redeemedAt, ordenar por redeemedAt
                                return b.redeemedAt - a.redeemedAt;
                            } else {

                                // Ninguno o solo uno tiene redeemedAt, ordenar por createdAt
                                return b.createdAt - a.createdAt;
                            }
                        });

                    return allTransactions;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de las órdenes: ${errMsg}`));
                }
            );
    }


    // GET api/admin/transactions/stores/reads/v1
    getPointTemplates(): Promise<any> {

        return this.http.get(`${this.baseUrl}/api/admin/categories/point-templates/reads/v1`, this.getHttpOptions())
            .toPromise();
    }

    // GET api/admin/transactions/stores/reads/v1
    getStores(): Promise<VendorStoreModel[]> {

        return this.http.get(`${this.baseUrl}/api/admin/transactions/stores/reads/v1`, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    const stores = results.map(x => {

                        return new VendorStoreModel(x);
                    });

                    return stores;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de los lugares de canje: ${errMsg}`));
                }
            );
    }

    // POST api/admin/transactions/pre-unique-link/create/v1
    preregisterCouponUniqueLink(transaction: TransactionTransferModel, country: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/pre-unique-link/create/v1`, transaction, this.getHttpOptionsWithoutSession(country))
            .toPromise();
    }

    // POST api/admin/transactions/get-unique-link/create/v1
    acceptUniqueLink(transaction: TransactionTransferModel, country?: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/get-unique-link/create/v1`, transaction, this.getHttpOptions(country))
            .toPromise();
    }

    // POST api/admin/transactions/get-unique-link/create/v1
    checkoutAcceptUniqueLink(transaction: TransactionTransferModel, country: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/get-unique-link/create/v1`, transaction, this.getHttpOptionsWithoutSession(country))
            .toPromise();
    }

    // POST api/admin/transactions/get-multiple-link/update/v1
    acceptMultipleLink(transaction: TransactionTransferModel): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/get-multiple-link/create/v1`, transaction, this.getHttpOptions())
            .toPromise();
    }


    // POST api/admin/transactions/pay-points/create/v1
    payOrderPoints(transaction: NewTransactionPointsModel): Promise<TransactionModel> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/pay-points/create/v1`, transaction, this.getHttpOptions())
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionModel(result);

                    return transaction;
                }
            );
    }

    // POST api/admin/transactions/pay-giftcards/create/v1
    payOrderGiftcard(transaction: NewTransactionGiftcardModel, country?: Country): Promise<TransactionModel> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/pay-giftcards/create/v1`, transaction, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionModel(result);

                    return transaction;
                }
            );
    }

    // POST api/admin/transactions/pay-products/create/v1
    payOrderProduct(transaction: NewTransactionProductModel): Promise<TransactionModel> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/pay-products/create/v1`, transaction, this.getHttpOptions())
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionModel(result);

                    return transaction;
                }
            );
    }

    // POST api/admin/transactions/pay-tickets/create/v1
    payOrderTicket(transaction: NewTransactionTicketModel, country?: Country): Promise<TransactionModel> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/pay-tickets/create/v1`, transaction, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionModel(result);

                    return transaction;
                }
            );
    }

    // POST api/admin/transactions/pay-packages/create/v1
    payOrderPackage(transaction: NewTransactionPackageModel, country?: Country): Promise<TransactionModel> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/pay-packages/create/v1`, transaction, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionModel(result);

                    return transaction;
                }
            );
    }

    // POST: api/admin/transactions/pay-coupon/create/v1
    payOrderCoupons(transaction: NewTransactionCouponModel, country?: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/pay-coupon/create/v1`, transaction, this.getHttpOptionsWithoutSession(country))
            .toPromise();
    }

    // PUT: api/admin/partner/sale-status-scanner/update/v1
    updateQRDownload(transaction: TransactionModel, country: Country): Promise<TransactionModel> {

        return this.http.put(`${this.baseUrl}/api/admin/transactions/sale-qr-download/update/v1`, transaction, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionModel(result);

                    return transaction;
                }
            );
    }

    // PUT: api/admin/transactions/send-email-ticket/create/v1
    sendEmailTicket(transactionId: number, country: Country): Promise<TransactionModel> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/send-email-ticket/create/v1/${transactionId}`, null, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionModel(result);

                    return transaction;
                }
            );
    }

    // POST api/admin/transactions/points/customer/create/v1
    createTransactionPoints(transaction: NewTransactionMarketCouponPointsModel): Promise<TransactionModel> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/points/customer/create/v1`, transaction, this.getHttpOptions())
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionModel(result);

                    return transaction;
                }
            );
    }


    // PUT api/admin/transactions/accept/update/v1
    acceptNewGivi(transaction: TransactionModel): Promise<any> {

        return this.http.put(`${this.baseUrl}/api/admin/transactions/accept/update/v1`, transaction, this.getHttpOptions())
            .toPromise();
    }

    // PUT api/admin/transactions/package/active/update/v1
    activeTransactionPackage(transaction: TransactionPackageModel): Promise<any> {

        return this.http.put(`${this.baseUrl}/api/admin/transactions/package/active/update/v1`, transaction, this.getHttpOptions())
            .toPromise();
    }

    // PUT api/admin/transactions/transfer/update/v1
    transferGivi(transaction: TransactionTransferModel, country?: Country): Promise<TransactionModel> {

        return this.http.put(`${this.baseUrl}/api/admin/transactions/transfer/update/v1`, transaction, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionModel(result);

                    return transaction;
                }
            );
    }

    // PUT api/admin/transactions/transfer/update/v1
    noSessiontransferGivi(transaction: TransactionTransferModel, country: Country): Promise<TransactionModel> {

        return this.http.put(`${this.baseUrl}/api/admin/transactions/transfer/update/v1`, transaction, this.getHttpOptionsWithoutSession(country))
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionModel(result);

                    return transaction;
                }
            );
    }


    // PUT api/admin/transactions/transfer-pack/update/v1
    transferPack(transaction: TransactionTransferModel, country?: Country): Promise<TransactionModel> {

        return this.http.put(`${this.baseUrl}/api/admin/transactions/transfer-pack/update/v1`, transaction, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionModel(result);

                    return transaction;
                }
            );
    }


    // POST api/admin/transactions/note/create/v1
    createTransactionNote(transaction: TransactionNotesModel, country?: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/note/create/v1`, transaction, this.getHttpOptions(country))
            .toPromise();
    }

    // PUT api/admin/transactions/note/update/v1
    updateTransactionNote(note: TransactionNotesModel, country?: Country): Promise<TransactionNotesModel> {

        return this.http.put(`${this.baseUrl}/api/admin/transactions/note/update/v1`, note, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    const transactionNote = new TransactionNotesModel(result);

                    return transactionNote;
                }
            );
    }

    // POST api/admin/transactions/package/note/create/v1
    createTransactionPackageNote(transaction: TransactionNotesModel, country?: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/package/note/create/v1`, transaction, this.getHttpOptions(country))
            .toPromise();
    }

    // PUT api/admin/transactions/package/note/update/v1
    updateTransactionPackageNote(note: TransactionNotesModel, country?: Country): Promise<TransactionNotesModel> {

        return this.http.put(`${this.baseUrl}/api/admin/transactions/package/note/update/v1`, note, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    const transactionNote = new TransactionNotesModel(result);

                    return transactionNote;
                }
            );
    }


    // PUT: api/admin/transactions/sale/status/update/v1
    accumulateCoupon(transaction: TransactionAccumulateModel, country?: Country): Promise<TransactionAccumulateModel> {

        return this.http.put(`${this.baseUrl}/api/admin/transactions/sale/status/update/v1`, transaction, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionAccumulateModel(result);

                    return transaction;
                }
            );
    }

    // PUT: api/admin/transactions/sale/status/update/v1
    checkoutAccumulateCoupon(transaction: TransactionAccumulateModel, country: Country): Promise<TransactionAccumulateModel> {

        return this.http.put(`${this.baseUrl}/api/admin/transactions/sale/status/update/v1`, transaction, this.getHttpOptionsWithoutSession(country))
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionAccumulateModel(result);

                    return transaction;
                }
            );
    }

    // PUT: api/admin/transactions/clear/received/update/v1/{id}
    clearTransactionsReceived(id: number): Promise<TransactionModel[]> {

        return this.http.put(`${this.baseUrl}/api/admin/transactions/clear/received/update/v1/${id}`, null, this.getHttpOptions())
            .toPromise().then(
                (result: any) => {

                    let transactions = result.map(x => new TransactionModel(x));
                    return transactions;
                }
            );
    }

    // DELETE: api/admin/transactions/points/status/delete/v1/{id}
    deleteTransactionCoupon(id: number): Promise<TransactionModel> {

        return this.http.delete(`${this.baseUrl}/api/admin/transactions/points/status/delete/v1/${id}`, this.getHttpOptions())
            .toPromise().then(
                (result: any) => {

                    const transaction = new TransactionModel(result);

                    return transaction;
                }
            );
    }

    // PUT api/admin/transactions/note/update/v1
    updateTransactionGreeting(greeting: TransactionGreetingModel): Promise<TransactionGreetingModel> {

        return this.http.put(`${this.baseUrl}/api/admin/transactions/greeting/update/v1`, greeting, this.getHttpOptions())
            .toPromise().then(
                (result: any) => {

                    const transactionGreeting = new TransactionGreetingModel(result);

                    return greeting;
                }
            );
    }

    // POST api/admin/transactions/delete/v1
    deleteTransaction(transaction: TransactionModel): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/delete/v1`, transaction, this.getHttpOptions())
            .toPromise();
    }

    // POST api/admin/transactions/pack-scratch-customer/delete/v1
    deletePackageScratchCustomer(packScratchCustomer: PackageScratchCustomerModel): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/pack-scratch-customer/delete/v1`, packScratchCustomer, this.getHttpOptions())
            .toPromise();
    }

    // POST api/admin/transactions/can-access-checkout/reads/v1
    checkUniqueLinkCode(code: string, country: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/can-access-checkout/reads/v1/${code}`, null, this.getHttpOptionsWithoutSession(country))
            .toPromise();
    }

    // Post: api/admin/transactions/can-access-pack/reads/v1/{code}
    checkUniquePackLinkCode(code: string, country: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/can-access-pack/reads/v1/${code}`, null, this.getHttpOptionsWithoutSession(country))
            .toPromise();
    }

    // POST: api/admin/loyaltyplans/sticker/assign/create/v1
    postAutoAssignLoyaltyPlanSticker(transaction: AssignCustomerStickerModel, country?: Country): Promise<LoyaltyPlanCustomerStickerModel> {

        return this.http.post(`${this.baseUrl}/api/admin/loyaltyplans/sticker/assign/create/v1`, transaction, this.getHttpOptions(country))
            .toPromise().then(
                (results: any) => {

                    let res = new LoyaltyPlanCustomerStickerModel(results);
                    return res;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información del plan de lealtad: ${errMsg}`));
                }
            );
    }

    //givi scan app

    // GET: api/admin/loyaltyplans/reads/v1/{id}/{customerId}
    getLoyaltyPlanGSA(id: number, customerId: number, country?: Country): Promise<LoyaltyPlanModel> {

        return this.http.get(`${this.baseUrl}/api/admin/loyaltyplans/reads/v1/${id}/${customerId}`, this.getHttpOptionsGSA(country))
            .toPromise().then(
                (results: any) => {

                    let plan = new LoyaltyPlanModel(results);

                    return plan;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información del plan de lealtad: ${errMsg}`));
                }
            );
    }
    // POST: api/admin/loyaltyplans/sticker/assign/create/v1
    postAssignLoyaltyPlanStiker(transaction: AssignCustomerStickerModel): Promise<LoyaltyPlanCustomerStickerModel> {

        return this.http.post(`${this.baseUrl}/api/admin/loyaltyplans/sticker/assign/create/v1`, transaction, this.getHttpOptionsGSA())
            .toPromise().then(
                (results: any) => {

                    let res = new LoyaltyPlanCustomerStickerModel(results);
                    return res;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información del plan de lealtad: ${errMsg}`));
                }
            );
    }

    // GET api/admin/transactions/reads/v1/{id}
    getTransactionGSA(id: number): Promise<TransactionModel> {

        return this.http.get(`${this.baseUrl}/api/admin/transactions/reads/v1/${id}`, this.getHttpOptionsGSA())
            .toPromise().then(
                (result: any) => {

                    const order = new TransactionModel(result);

                    return order;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de la orden: ${errMsg}`));
                }
            );
    }

    // PUT: api/admin/partner/sale-status-scanner/update/v1
    updateGiviStatusScannerGSA(order: QRInformation): Promise<any> {

        return this.http.put(`${this.baseUrl}/api/admin/partner/sale-status-scanner/update/v1`, order, this.getHttpOptionsGSA())
            .toPromise();
    }
    
    // GET: api/admin/products/parent-giftcard/reads/v1/{id}/{communityId}
    getMarketplaceGiftcard(vendorId: number, communityId: number, country: Country): Promise<GiftcardModel[]> {

        return this.http.get(`${this.baseUrl}/api/admin/products/parent-giftcard/reads/v1/${vendorId}/${communityId}`, this.getHttpOptionsWithoutSession(country))
            .toPromise().then(
                (results: any) => {

                    const giftcards = results.map(x => {

                        return new GiftcardModel(x);
                    });

                    return giftcards;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de la orden: ${errMsg}`));
                }
            );
    }

    // GET: api/admin/products/giftcard/reads/v1/{id}
    getCheckoutGiftcards(vendorId: number, communityId: number, country: Country): Promise<GiftcardModel[]> {

        return this.http.get(`${this.baseUrl}/api/admin/products/giftcard/reads/v1/${vendorId}/${communityId}`, this.getHttpOptionsWithoutSession(country))
            .toPromise().then(
                (results: any) => {

                    const giftcards = results.map(x => {

                        return new GiftcardModel(x);
                    });

                    return giftcards;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de la orden: ${errMsg}`));
                }
            );
    }

    // GET: api/admin/tickets/events/reads/full/v1/{id}
    getCheckoutEvents(eventId: number, country: Country): Promise<TicketModel[]> {

        return this.http.get(`${this.baseUrl}/api/admin/tickets/events/reads/full/v1/${eventId}`, this.getHttpOptionsWithoutSession(country))
            .toPromise().then(
                (results: any) => {

                    const events = results.map(x => {

                        return new TicketModel(x);
                    });

                    return events;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de la orden: ${errMsg}`));
                }
            );
    }

    // GET: api/admin/products/app/reads/v1/{id}
    getCheckoutProduct(productId: number, country: Country): Promise<ProductModel> {

        return this.http.get(`${this.baseUrl}/api/admin/products/app/reads/v1/${productId}`, this.getHttpOptionsWithoutSession(country))
            .toPromise().then(
                (result: any) => {

                    const product = new ProductModel(result);

                    return product;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de la orden: ${errMsg}`));
                }
            );
    }

    // GET api/admin/coupons/reads/v1/{id}
    getCheckoutBasicCoupon(id: number, country: Country): Promise<CouponModel> {

        return this.http.get(`${this.baseUrl}/api/admin/coupons/reads/v1/${id}`, this.getHttpOptionsWithoutSession(country))
            .toPromise().then(
                (result: any) => {

                    const coupon = new CouponModel(result);

                    return coupon;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información del cupón: ${errMsg}`));
                }
            );
    }

    // POST: api/admin/transactions/pay-products/create/v1
    payCheckoutProduct(transaction: NewTransactionProductModel, country: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/pay-products/create/v1`, transaction, this.getHttpOptionsWithoutSession(country))
            .toPromise();
    }

    // POST: api/admin/transactions/pay-giftcards/create/v1
    payCheckoutGiftcard(transaction: NewTransactionGiftcardModel, country: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/pay-giftcards/create/v1`, transaction, this.getHttpOptionsWithoutSession(country))
            .toPromise();
    }

    // POST: api/admin/transactions/pay-tickets/create/v1
    payCheckoutTickets(transaction: NewTransactionTicketModel, country: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/pay-tickets/create/v1`, transaction, this.getHttpOptionsWithoutSession(country))
            .toPromise();
    }

    // POST: api/admin/transactions/pay-multiple-giftcards/create/v1
    payMultipleGiftcards(transaction: NewTransactionGiftcardModel, country: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/pay-multiple-giftcards/create/v1`, transaction, this.getHttpOptionsWithoutSession(country))
            .toPromise();
    }

    // POST: api/admin/transactions/pay-coupon/create/v1
    payCheckoutCoupons(transaction: NewTransactionCouponModel, country: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/pay-coupon/create/v1`, transaction, this.getHttpOptionsWithoutSession(country))
            .toPromise();
    }

    // GET: api/admin/partner/vendor-stores-customers/reads/v1/{id}
    getVendorsStoresCustomer(id: number): Promise<VendorStoreCustomer[]> {

        return this.http.get(`${this.baseUrl}/api/admin/partner/vendor-stores-customers/reads/v1/${id}`, this.getHttpOptions())
            .toPromise().then(
                (result: any) => {

                    const vendorStoresCustomer = result.map(x => {

                        return new VendorStoreCustomer(x);
                    });

                    return vendorStoresCustomer;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de la orden: ${errMsg}`));
                }
            );
    }

    // PUT: api/admin/account/card/verify/update/v1
    putVerifyCard(customerCard: CustomerCardIssueModel): Promise<any> {

        return this.http.put(`${this.baseUrl}/api/admin/account/card/verify/update/v1`, customerCard, this.getHttpOptions())
            .toPromise();
    }


    requestCardVerification(customerCard: CustomerCardModel, type: CardIssueType): Promise<any> {

        const verifyCard = new CustomerCardIssueModel({
            token: customerCard.token,
            customerId: customerCard.customerId,
            type: type,
            status: CardIssueStatus.Pending
        });

        return this.putVerifyCard(verifyCard);
    }

    // POST api/admin/transactions/get-unique-link/create/v1
    getUniqueLink(transaction: TransactionTransferModel, country?: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/get-unique-link/create/v1`, transaction, this.getHttpOptions(country))
            .toPromise();
    }

    // POST api/admin/transactions/get-multiple-link/update/v1
    getMultipleLink(transaction: TransactionTransferModel, country?: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/get-multiple-link/create/v1`, transaction, this.getHttpOptions(country))
            .toPromise();
    }

    // Post: api/admin/transactions/customer-giveaway/create/v1
    postCustomerGiveaway(customerGiveaway: CustomerGiveawayRegisterModel, country?: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/customer-giveaway/create/v1`, customerGiveaway, this.getHttpOptions(country))
            .toPromise();
    }

    // Post: api/admin/transactions/customer-giveaway/create/v1 (sin sesión, raspadita pública)
    withoutSessionPostCustomerGiveaway(customerGiveaway: CustomerGiveawayRegisterModel, country: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/customer-giveaway/create/v1`, customerGiveaway, this.getHttpOptionsWithoutSession(country))
            .toPromise();
    }

    // POST: api/admin/transactions/pre-scratch/create/v1 (sin sesión, raspadita pública)
    preregisterScratch(transaction: TransactionTransferModel, country: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/pre-scratch/create/v1`, transaction, this.getHttpOptionsWithoutSession(country))
            .toPromise();
    }

    // Post: api/admin/transactions/can-access-scratch/reads/v1/{code}
    checkUniqueScratchLinkCode(code: string): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/can-access-scratch/reads/v1/${code}`, null, this.getHttpOptions())
            .toPromise();
    }

    // Post: api/admin/transactions/can-access-scratch/reads/v1/{code} (sin sesión, raspadita pública)
    withoutSessionCheckUniqueScratchLinkCode(code: string, country: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/transactions/can-access-scratch/reads/v1/${code}`, null, this.getHttpOptionsWithoutSession(country))
            .toPromise();
    }

    // GET: api/admin/tickets/events/reads/full/v1/{id}
    getTicketByEvent(eventId: number): Promise<TicketModel[]> {

        return this.http.get(`${this.baseUrl}/api/admin/tickets/events/reads/full/v1/${eventId}`, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    const tickets = results.map(x => {

                        return new TicketModel(x);
                    });

                    return tickets;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de la orden: ${errMsg}`));
                }
            );
    }

    // GET: api/admin/products/giftcard/reads/v1/{id}/{communityId}
    getGiftcardsByVendor(vendorId: number, communityId: number): Promise<GiftcardModel[]> {

        return this.http.get(`${this.baseUrl}/api/admin/products/giftcard/reads/v1/${vendorId}/${communityId}`, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    const giftcards = results.map(x => {

                        return new GiftcardModel(x);
                    });

                    return giftcards;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de la orden: ${errMsg}`));
                }
            );
    }
}
